/**
 * @generated SignedSource<<3ec2a895ceddd3487d6c416e6555d507>>
 * @relayHash b787391dfecb60b98d70bd21d1a966cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 92634ac69886405bf93a0c1c5090a69c60dffd5712989db97cba22531f4d0381

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DashboardsContentViewQuery } from './DashboardsContentViewQuery.graphql';

import isAvpJdMergedDirectoryEnabled_provider from '@jira/platform__graphql-relay-provider/src/platformAvpJdMergedDirectoryAfmRelayProvider';

const node: PreloadableConcreteRequest<DashboardsContentViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "92634ac69886405bf93a0c1c5090a69c60dffd5712989db97cba22531f4d0381",
    "metadata": {},
    "name": "DashboardsContentViewQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcplatformAvpJdMergedDirectoryAfmRelayProvidertsx": isAvpJdMergedDirectoryEnabled_provider
    }
  }
};

export default node;
